import { Component, EventEmitter, forwardRef, Inject, Input, OnChanges, Optional, Output } from "@angular/core";
import { PageActionsComponent } from "@directives/_layout/_page-design/page-actions/page-actions.component";
import { TranslationService } from "@services/translation.service";
import { DefaultLayoutComponent } from "../../_layout/_page-design/_layouts/default-layout/default-layout.component";
import "./veriSearchBox.scss";

@Component({
    selector: "veri-search-box",
    template: require("./veriSearchBox.template.html")
})
export class VeriSearchBoxComponent implements OnChanges {
    @Input() search: string;

    @Input() placeholder: string;
    @Input() placeholderCount: number;
    @Input() greyBackground: boolean;

    @Output() searchChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() onChange: EventEmitter<any> = new EventEmitter<string>();

    // ---

    translatedPlaceholder: string;

    constructor(
        @Optional() @Inject(forwardRef(() => DefaultLayoutComponent)) private parent: DefaultLayoutComponent,
        @Optional() @Inject(forwardRef(() => PageActionsComponent)) private pageActions: PageActionsComponent,
        private readonly translationService: TranslationService) {
        pageActions?.registerSearchBox(this);
    }

    ngOnChanges() {
        this.updatePlaceholderTranslation();
    }

    setSearchValue(value: string) {
        this.search = value;
        this.searchBoxChange();
    }

    searchBoxChange() {
        this.searchChange.emit(this.search); // Use this
        this.onChange.emit(this.search);
    }

    clearSearchTerm() {
        this.search = "";
        this.searchBoxChange();
    }

    // ---

    updatePlaceholderTranslation() {

        if (this.placeholder && this.placeholderCount) {
            this.translatedPlaceholder = this.translationService.t("VeriSearchBox.PlaceholderWithLabelAndCount", [this.placeholder, this.placeholderCount.toLocaleString()]);
        }
        else if (this.placeholder) {
            this.translatedPlaceholder = this.translationService.t("VeriSearchBox.PlaceholderWithLabel", this.placeholder);
        }
        else if (this.placeholderCount) {
            this.translatedPlaceholder = this.translationService.t("VeriSearchBox.PlaceholderWithCount", this.placeholderCount.toLocaleString());
        }
        else {
            this.translatedPlaceholder = this.translationService.t("VeriSearchBox.Placeholder");
        }
    }
}
